import React from 'react';
import { FaRegFileAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { GridItem } from '@chakra-ui/react';
import { SettingsCard } from '../../../components/SettingsCard';
import './gridRelatorios.scss';

const GridRelatorios = () => {
  const navigate = useNavigate();

  const submenus = [
    {
      cardTitle: 'Relatório de rede social',
      path: 'relatorio-rede-social',
      icon: FaRegFileAlt,
    }
  ];

  return (
    <div className="main-container-grid">
      {submenus.map((submenu, index) => (
        <GridItem key={index}>
          <SettingsCard
            buttonText="Acessar"
            onClick={() => navigate(submenu.path)}
            icon={submenu.icon}
            cardTitle={submenu.cardTitle}
          />
        </GridItem>
      ))}
    </div>
  );
};

export default GridRelatorios;
